import { render, staticRenderFns } from "./AdminAppShowPhoto.vue?vue&type=template&id=f25cfe04&scoped=true"
import script from "./AdminAppShowPhoto.vue?vue&type=script&lang=js"
export * from "./AdminAppShowPhoto.vue?vue&type=script&lang=js"
import style0 from "./AdminAppShowPhoto.vue?vue&type=style&index=0&id=f25cfe04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25cfe04",
  null
  
)

export default component.exports